import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// maplibre のベース CSS を先に読み、自前の styles.css で上書きできるようにする
// （逆順だと .maplibregl-map { position: relative } が .map の absolute 配置を潰し高さ 0 になる）
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root not found');

createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker (Web Push 用)。失敗してもアプリ本体は動作する。
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch((err) => {
    console.warn('SW registration failed', err);
  });
}
